module.exports = __webpack_public_path__ + "static/img/image_we_09_02.d265c5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_09_02.png
// module id = Unpr
// module chunks = 10